<template>
  <button
    class="bg-static-default-low mood-tangaroa rounded-r-xs rounded-l-md relative inline-flex cursor-pointer items-center self-start py-4 pl-6 pr-24"
    data-test="jpp-verified-refurbished-tag"
    @click="openRefurbishedModal"
  >
    <IconBackMarket class="text-static-default-hi mr-4" />
    <p class="text-static-default-low body-2-bold underline">
      {{ i18n(translations.verifiedRefurbishedTagLabel) }}
    </p>
    <div
      class="border-r-static-default-mid absolute -right-1 top-1 h-0 w-0 border-b-[15px] border-r-10 border-t-[15px] border-b-transparent border-l-transparent border-t-transparent"
    />
  </button>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { openModal } from '@ds/components/ModalBase'
import { IconBackMarket } from '@ds/icons/IconBackMarket'

import { MODAL_NAMES } from '~/scopes/product/pages/Product-JP/Product-JP.constants'

import translations from './VerifiedRefurbishedTag.translations'

const i18n = useI18n()
const { trackClick } = useTracking()

const openRefurbishedModal = () => {
  openModal(MODAL_NAMES.VERIFIED_REFURBISHED_JPP)
  trackClick({
    zone: 'verified_refurbished_info',
    name: 'verified_refurbished',
  })
}
</script>
